import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 8px;
  width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.bg.secondary};

  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.text.text};
`;

export const Link = styled.a`
  all: unset;
  cursor: pointer;
  color: ${({ theme }) => theme.text.brand};
`;
